export const defaultFeatureFlags = {
  'feature.multihost.show-network-warnings': false,
  'feature.multihost.show-higher-bitrates': false,
  'feature.multihost.disable-agora-congestion-control': false,
};

export type FeatureFlagType = keyof typeof defaultFeatureFlags;
